module.exports = __webpack_public_path__ + "img/wd-bg1-0385e4.png";